export default "__VITE_ASSET__BJDtZ58I__"